
export default {
    ROOM_INIT: function(state, roomData){
        state.roomCall = Object.assign(state.roomCall, roomData.roomCall)
    },
    changeCallType: function(state, data){
        const settings = data.settings;
        const {callType, layoutType} = settings;
        state.roomCall.callType = callType;
        state.roomCall.videoLayout = layoutType;
    },
    showConnectionStats: function(state, data){
        state.showConnectionStats = true;
        state.showConnectionStatsWindow = !!data.window;
    },
    hideConnectionStats: function(state, data){
        state.showConnectionStats = false;
    },
    toggleConnectionStats: function(state, data){
        let s = !state.showConnectionStats;
        state.showConnectionStats = s;
        state.showConnectionStatsWindow = !!data.window;
    },
    // mixerConnectionStats: function(state, data){
    //     state.mixerConnectionStats = data;
    // },

    SET_ROOM_CALL_VIDEO_LAYOUT: (state, layoutType) => {
        if(!layoutType) return

        state.roomCall.isEmptyLayoutType =
            layoutType.startsWith('ml_clone_empty') ||
            layoutType.startsWith('ml_clone_le')
        state.roomCall.videoLayout = layoutType
    },
    SET_ROOM_CALL_MIXING_LAYOUT: (state, data) => {
        state.roomCall.mixingLayoutData = data;
    },
    changeVideoQuality: (state, data) => {
        const {videoQuality} = data;
        state.roomCall.videoQuality = videoQuality
    },
    CHANGE_WEBINAR_TYPE: (state, data) => {
        const {webinarType} = data;
        state.roomCall.webinarType = webinarType
    },
    REQUEST_UNMUTE: (state, data) => {
        const {callback} = data;
        if(!state.roomCall.requestUnmute) {
            callback();
        }
        state.roomCall.requestUnmute = true;
    },
    SET_USER_GESTURE_INIT: (state, data) => {
        state.roomCall.userGestureInit = true;
    },
    changeHideRoomGroupUserInFilmArea: (state, data) => {
        const {hideRoomGroupUserInFilmArea} = data;
        state.roomCall.hideRoomGroupUserInFilmArea = hideRoomGroupUserInFilmArea
    }
}
